import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles<Theme, {}>(
  _ => ({
    cardStyle: {
      marginBottom: 16
    },
    cardTitle: {
      "& span": {
        fontWeight: "bold"
      }
    }
  }),
  { name: "CouponTaggingCard" }
);
